import script from "./TotalValueOfMintsOverTimeChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalValueOfMintsOverTimeChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__